module.exports = {
    name:'星途保',
    apihost:'https://api.xtb365.cn',
    // apihost:'http://xtb.test/api/public',
    apimit:{
        device:'PC_USER',
        compiled:{
            PC_USER:"dhauo1234420123gg3234901",// 接口Sign混淆秘钥
        }
    },
}